import {
  base_colorContentBorder,
  base_colorSurfaceSecondary,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { cornerRadius, spacing } from 'ext-ui/style/spacing'
import { font_md } from 'ext-ui/style/typography'
import { chartsGrid } from 'src/charting/reportingCardLayout.style'
import { css } from 'styled-components'

export const section = css`
  display: flex;
  flex-direction: column;
  gap: ${spacing(4)};
`

export const grid = css`
  ${chartsGrid}
`

export const skeletonCard = css`
  display: flex;
  box-sizing: border-box;
  height: ${spacing(60)};
  min-height: ${spacing(60)};
  flex-direction: column;
  gap: ${spacing(4)};
  padding: ${spacing(4)};
  border: 1px solid ${base_colorContentBorder};
  border-radius: ${cornerRadius};
  background: ${base_colorSurfaceSecondary};
`

/** Reserved on the observed wrapper before the live result is fetched. */
export const liveCardSlot = css`
  box-sizing: border-box;
  height: ${spacing(60)};
  min-height: ${spacing(60)};
`

export const skeletonHeading = css`
  width: 45%;
  height: ${spacing(4)};
  border-radius: ${spacing(1)};
  background: ${base_colorContentBorder};
`

export const skeletonBody = css`
  flex: 1;
  border-radius: ${spacing(1)};
  background: ${base_colorContentBorder};
`

export const errorHeading = css`
  ${font_md};
  margin: 0;
`

export const empty = css`
  ${font_md};
  margin: 0;
  color: ${text_colorTextSecondary};
`

export const error = css`
  ${font_md};
  margin: 0;
  color: ${text_colorTextSecondary};
`
